// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--FBa0e";
export var footerInfoContainer = "footer-module--footerInfoContainer--3Kydp";
export var footerButton = "footer-module--footerButton--HSgXl";
export var footerLogo = "footer-module--footerLogo--EGm5k";
export var footerHeading = "footer-module--footerHeading--2y3Wz";
export var contact = "footer-module--contact--4BxwS";
export var copyright = "footer-module--copyright--1B3BS";